import { ChatPromptTemplate } from '@langchain/core/prompts';

import { useMemo } from 'react';

import { emptyStructuredPromptManifest } from '@/Pages/HubPlayground/HubPlayground.utils';
import {
  createPlaygroundManifest,
  defaultChatModelManifest,
} from '@/Pages/Playground/utils/Playground.utils';
import { convertSerializedMessagesToMessageTuple } from '@/components/Rules/RulesEvaluatorPane.utils';

import { useEvaluatorStore } from '../store/evaluatorStore';
import { EvaluatedEntityType } from './serializeFeedbackUIToLC';

export function usePromptTypeManifest(
  evaluatedEntityType: EvaluatedEntityType
) {
  const promptMessages = useEvaluatorStore((state) => state.promptMessages);
  const promptTemplateFormat = useEvaluatorStore(
    (state) => state.promptTemplateFormat
  );
  const promptSchema = useEvaluatorStore((state) => state.feedbackSchema);
  const model = useEvaluatorStore((state) => state.model);

  const manifest = useMemo(() => {
    const messages =
      promptMessages ??
      convertSerializedMessagesToMessageTuple(
        emptyStructuredPromptManifest(
          evaluatedEntityType,
          null,
          promptTemplateFormat ?? 'mustache'
        ).kwargs.messages
      );

    const prompt = JSON.parse(
      JSON.stringify(
        ChatPromptTemplate.fromMessages(messages, {
          templateFormat: promptTemplateFormat ?? 'mustache',
        })
      )
    );

    prompt.kwargs.schema = promptSchema;
    return createPlaygroundManifest(prompt, model ?? defaultChatModelManifest);
  }, [
    model,
    promptMessages,
    promptSchema,
    promptTemplateFormat,
    evaluatedEntityType,
  ]);

  return manifest;
}
